import React, { Suspense, lazy } from 'react';
import { APP_VARIANT } from './config';

const AppA = lazy(() => import('./apps/a/AppA'));
const AppB = lazy(() => import('./apps/b/AppB'));

export const isVersionBPath = (pathname: string | undefined = typeof window === 'undefined' ? '' : window.location.pathname): boolean =>
  pathname === '/version-b' || Boolean(pathname?.startsWith('/version-b/'));

export const shouldShowVersionB = (variant = APP_VARIANT, pathname: string | undefined = typeof window === 'undefined' ? '' : window.location.pathname): boolean =>
  variant === 'B' || isVersionBPath(pathname);

function App() {
  const showVersionB = shouldShowVersionB();

  return (
    <Suspense fallback={null}>
      {showVersionB ? <AppB /> : <AppA />}
    </Suspense>
  );
}

export default App;
